import { render, staticRenderFns } from "./train.vue?vue&type=template&id=3b4128a6&scoped=true&"
import script from "./train.vue?vue&type=script&lang=js&"
export * from "./train.vue?vue&type=script&lang=js&"
import style0 from "./train.vue?vue&type=style&index=0&id=3b4128a6&scoped=true&lang=less&"
import style1 from "./train.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4128a6",
  null
  
)

export default component.exports